        <nav class="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
            <div class="container">
                <a class="navbar-brand js-scroll-trigger" href="#page-top">Home</a>
                <!-- <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                    Menu
                    <i class="fas fa-bars"></i>
                </button> class="collapse navbar-collapse" id="navbarResponsive" -->
                <div>
                    <ul class="navbar-nav ml-auto">
                        <!-- <li class="nav-item"><a class="nav-link js-scroll-trigger" href="#about">A propos</a></li> -->
                        <li class="nav-item"><a class="nav-link js-scroll-trigger" [routerLink]="['/cgu']" >CGU</a></li>
                        <!-- <li class="nav-item"><a class="nav-link js-scroll-trigger" href="#signup">Contact</a></li> -->
                    </ul>
                </div>
                <!-- <a class="btn btn-primary js-scroll-trigger" (click)="openDialogConnexion()">Se connecter</a> -->
            </div>
        </nav>
        <!-- Masthead-->
        <header class="masthead">
            <div class="container d-flex h-100 align-items-center">
                <div class="mx-auto text-center">
                    <h1 class="mx-auto my-0 text-uppercase">Receipt2Go</h1>
                    <h2 class="text-white-50 mx-auto mt-2 mb-5">L'application gratuite pour générer et envoyer vos quittances en une minute</h2>
                    <!-- <a class="btn btn-primary js-scroll-trigger" (click)="openDialogConnexion()">Commencez</a> -->
                    <a class="btn btn-primary js-scroll-trigger" href="/home#about">Commencez</a>
                </div>
            </div>
        </header>
        <!-- About-->
        <section class="about-section text-center" id="about">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 mx-auto">
                        <h2 class="text-white mb-4">Utiliser l'application</h2>
                        <p class="text-white-50">
                            Receipt2Go est une application mobile sur ios et android.
                            Aprés avoir enregistré un bailleur, un locataire et une location vous pouvez générer vos quittances en 30 secondes chaque mois.
                            Et ensuite vous pouvez l'envoyer par mail a votre locataire.
                        </p>
                    </div>
                </div>
                <img class="img-fluid" src="assets/img/ipad2.png" alt="" />
            </div>
        </section>
        <!-- Projects-->
        <section class="projects-section bg-light" id="cgu">
            <div class="container">
                <!-- Featured Project Row-->
                <div class="row align-items-center no-gutters mb-4 mb-lg-5">
                    <div class="col-xl-8 col-lg-7"><img class="img-fluid mb-3 mb-lg-0" src="assets/img/ipad-receipt2go.png" alt="" /></div>
                    <div class="col-xl-4 col-lg-5">
                        <div class="featured-text text-center text-lg-left">
                            <h4>Les quittances</h4>
                            <p class="text-black-50 mb-0">Receipt2go une application où il suffit de paramétrer ses bailleurs et ses locataires une seule fois et ensuite en 30 secondes par mois vous envoyez les quittances à vos locataires.</p>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center no-gutters mb-4 mb-lg-5">
                    <div class="col-xl-4 col-lg-5">
                        <div class="featured-text text-center text-lg-left">
                            <h4>Les états des lieux</h4>
                            <p class="text-black-50 mb-0">Réalisé rapidement et simplement vos états des lieux</p>
                        </div>
                    </div>
                    <div class="col-xl-8 col-lg-7"><img class="img-fluid mb-3 mb-lg-0" src="assets/img/demo-image-02.jpg" alt="" /></div>
                </div>
                <!-- Project One Row-->
                <div class="row justify-content-center no-gutters mb-5 mb-lg-0">
                    <div class="col-lg-6"><img class="img-fluid" src="assets/img/demo-image-01.jpg" alt="" /></div>
                    <div class="col-lg-6">
                        <div class="bg-black text-center h-100 project">
                            <div class="d-flex h-100">
                                <div class="project-text w-100 my-auto text-center text-lg-left">
                                    <h4 class="text-white">Apple</h4>
                                    <p class="mb-0 text-white-50">Accéder directement à l'apple store pour télécharger l'application.</p>
                                    <br>
                                    <p><img class="img-fluid" src="assets/img/buttonAppSTore.png" alt="" (click)="goToIos()" width="120" style="cursor: pointer;"/></p>
                                    <hr class="d-none d-lg-block mb-0 ml-0" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Project Two Row-->
                <div class="row justify-content-center no-gutters">
                    <div class="col-lg-6"><img class="img-fluid" src="assets/img/demo-image-02.jpg" alt="" /></div>
                    <div class="col-lg-6 order-lg-first">
                        <div class="bg-black text-center h-100 project" >
                            <div class="d-flex h-100">
                                <div class="project-text w-100 my-auto text-center text-lg-right">
                                    <h4 class="text-white">Android</h4>
                                    <p class="mb-0 text-white-50">Accéder directement à google play pour télécharger l'application.</p>
                                    <br>
                                    <p><img class="img-fluid" src="assets/img/buttonGooglePlay.png" alt="" (click)="goToAndroid()" width="120" style="cursor: pointer;"/></p>
                                    <hr class="d-none d-lg-block mb-0 mr-0" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Signup-->
        <!-- <section class="signup-section" id="signup">
            <div class="container">
                <div class="row">
                    <div class="col-md-10 col-lg-8 mx-auto text-center">
                        <i class="far fa-paper-plane fa-2x mb-2 text-white"></i>
                        <h2 class="text-white mb-5">Subscribe to receive updates!</h2>
                        <form class="form-inline d-flex">
                            <input class="form-control flex-fill mr-0 mr-sm-2 mb-3 mb-sm-0" id="inputEmail" type="email" placeholder="Enter email address..." />
                            <button class="btn btn-primary mx-auto" type="submit">Subscribe</button>
                        </form>
                    </div>
                </div>
            </div>
        </section> -->
        <!-- Contact-->
        <section class="contact-section bg-black">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 mb-3 mb-md-0">
                        <!-- <div class="card py-4 h-100">
                            <div class="card-body text-center">
                                <i class="fas fa-map-marked-alt text-primary mb-2"></i>
                                <h4 class="text-uppercase m-0">Address</h4>
                                <hr class="my-4" />
                                <div class="small text-black-50">4923 Market Street, Orlando FL</div>
                            </div>
                        </div> -->
                    </div>
                    <div class="col-md-4 mb-3 mb-md-0">
                        <div class="card py-4 h-100">
                            <div class="card-body text-center">
                                <i class="fas fa-envelope text-primary mb-2"></i>
                                <h4 class="text-uppercase m-0">Email</h4>
                                <hr class="my-4" />
                                <div class="small text-black-50"><a href="#!">receipt2go.contact@gmail.com</a></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 mb-3 mb-md-0">
                        <!-- <div class="card py-4 h-100">
                            <div class="card-body text-center">
                                <i class="fas fa-mobile-alt text-primary mb-2"></i>
                                <h4 class="text-uppercase m-0">Phone</h4>
                                <hr class="my-4" />
                                <div class="small text-black-50">+1 (555) 902-8832</div>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="social d-flex justify-content-center">
                    <!-- <a class="mx-2" href="#!"><i class="fab fa-twitter"></i></a>
                    <a class="mx-2" href="#!"><i class="fab fa-facebook-f"></i></a> -->
                    <!-- <a class="mx-2" href="#!"><i class="fab fa-github"></i></a> -->
                </div>
            </div>
        </section>
